import { FC } from "react";
import styles from "./SpinIndicator.module.scss";

const FreeSpinIndicator: FC<{ roulette: any }> = ({ roulette }) => {
  const rouletteArray = Array.isArray(roulette) ? roulette : [];
  const usedFreeSpins = rouletteArray.filter(
    (item) => item.txKey === "8hoursActivity" && item.used
  ).length;

  const totalFreeSpins = 3;
  const usedSpinsToShow = Math.min(usedFreeSpins, totalFreeSpins);

  const filledSquares = Array.from({ length: usedSpinsToShow }, (_, i) => (
    <span key={`filled-${i}`} style={{ fontSize: "25px" }}>
      ■
    </span>
  ));

  const emptySquares = Array.from(
    { length: totalFreeSpins - usedSpinsToShow },
    (_, i) => (
      <span key={`empty-${i}`} style={{ fontSize: "25px" }}>
        □
      </span>
    )
  );

  return (
    <div className={styles.freeSpinTooltip}>
      <div>
        {filledSquares}
        {emptySquares}
      </div>
      <span className={styles.text}>
        3 free spins every 24h — use them to unlock streak bonus!
      </span>
    </div>
  );
};

export default FreeSpinIndicator;
